import http from '../../../utils/tools/http';

import {
  COURSE_FETCH_GET_STU_COURSE_LIST_BEGIN,
  COURSE_FETCH_GET_STU_COURSE_LIST_SUCCESS,
  COURSE_FETCH_GET_STU_COURSE_LIST_FAILURE,
  COURSE_FETCH_GET_STU_COURSE_LIST_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchGetStuCourseList(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: COURSE_FETCH_GET_STU_COURSE_LIST_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = http.get({
        url: "/datastore/WebCourse/GetStuCourseList", params: {
          ...args, ...{
            Valid: 1,
            IsPutaway: 1,
            IsRecommend: -1,
          }
        }
      })
      doRequest.then(
        (res) => {
          dispatch({
            type: COURSE_FETCH_GET_STU_COURSE_LIST_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COURSE_FETCH_GET_STU_COURSE_LIST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchGetStuCourseListError() {
  return {
    type: COURSE_FETCH_GET_STU_COURSE_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COURSE_FETCH_GET_STU_COURSE_LIST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchGetStuCourseListPending: true,
        fetchGetStuCourseListError: null,
      };

    case COURSE_FETCH_GET_STU_COURSE_LIST_SUCCESS:
      // The request is success
     
      return {
        ...state,
        fetchGetStuCourseListPending: false,
        fetchGetStuCourseListSuccess: action.data.Data,
        fetchGetStuCourseListTotal: action.data.TotalCount > 0 ? action.data.TotalCount : state.fetchGetStuCourseListTotal,
      };

    case COURSE_FETCH_GET_STU_COURSE_LIST_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchGetStuCourseListPending: false,
        fetchGetStuCourseListError: action.data.error,
      };

    case COURSE_FETCH_GET_STU_COURSE_LIST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchGetStuCourseListError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/course/redux/fetchGetStuCourseList.js